<!-- Component for displaying the switch user modal -->
<template>
	<PrecoaModal
		:open="modelValue"
		@update:open="(value) => emit('update:modelValue', value ?? false)"
		@submit="handleConfirm"
	>
		<template #default>
			<div class="flex flex-col items-center text-center">
				<ExclamationTriangleIcon class="mb-3 h-10 w-10 text-yellow-400" />
				<h2 class="text-secondary-900 mb-2 text-lg font-semibold">
					{{
						t('auth.warningDeletesDataTitle', { event: t('auth.switchUser') })
					}}
				</h2>
				<p class="text-secondary-600 text-sm">
					{{ t('auth.warningDeletesDataMessage') }}
				</p>
				<p class="text-primary-800 mt-2 text-sm font-bold">
					{{ t('auth.cannotBeUndone') }}
				</p>
			</div>
		</template>

		<template #buttons>
			<FormKit
				type="button"
				@click="emit('update:modelValue', false)"
				input-class="border px-5 py-2 rounded-md font-bold w-full justify-center"
			>
				{{ t('general.cancel') }}
			</FormKit>

			<FormKit
				type="submit"
				input-class="border px-4 py-2 rounded-md font-bold  w-full justify-self-end justify-center"
			>
				{{ t('auth.confirmActionAndDelete', { event: t('auth.switchUser') }) }}
			</FormKit>
		</template>
	</PrecoaModal>
</template>

<script setup lang="ts">
import PrecoaModal from '@/components/common/PrecoaModal.vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
	modelValue: boolean
}>()

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void
	(e: 'confirm'): void
}>()

function handleConfirm() {
	emit('confirm')
	emit('update:modelValue', false)
}
</script>
